import React from 'react';
import { CheckIcon } from '../icons';
import CompareClaims from '../CompareClaims';
import DiscountPrice from './DiscountPrice';
import { COMPARE_DATA } from '../../data/homepageData';
import { cardImage } from '../../utils/productImages';

// Aluminium pergolas showcase. UX-14: rendered with the
// .asg-compare--coming-soon modifier so cards are visually
// desaturated and each carries a "Coming Soon" badge — keeps
// pergolas visually distinct from the buyable awnings above.
export default function PergolasShowcase({ pergolaProducts }) {
  if (pergolaProducts.length === 0) return null;
  return (
    <section className="asg-compare asg-compare--coming-soon" id="pergolas-range">
      <div className="asg-compare-inner">
        <div className="asg-compare-header asg-reveal">
          <p className="asg-section-label">Aluminium Pergolas - Available by Enquiry</p>
          <h2 className="asg-section-title">Three pergola systems.<br />Infinite configurations.</h2>
        </div>

        <div className="asg-compare-grid asg-compare-grid--three asg-reveal">
          {pergolaProducts.map((p) => {
            const slug = p.slug || '';
            const meta = COMPARE_DATA[slug] || {};
            const isPopular = slug === 'pergola-175';
            return (
              <div className={`asg-compare-card asg-compare-card--coming-soon${isPopular ? ' asg-compare-popular' : ''}`} key={p._id}>
                <span className="asg-compare-badge asg-compare-badge--coming-soon">Contact Us</span>
                <div className="asg-compare-img">
                  {cardImage(p) ? (
                    <img src={cardImage(p)} alt={p.name} width={400} height={267} loading="lazy" />
                  ) : (
                    <div className="asg-compare-img-placeholder"></div>
                  )}
                </div>
                {meta.tagline && <p className="asg-compare-tagline">{meta.tagline}</p>}
                <h3 className="asg-compare-name">{p.name}</h3>
                <DiscountPrice product={p} />
                {meta.bullets && meta.bullets.length > 0 ? (
                  <ul className="asg-compare-bullets">
                    {meta.bullets.map((b, i) => (
                      <li key={i}><CheckIcon />{b}</li>
                    ))}
                  </ul>
                ) : p.short_description ? (
                  <p className="asg-compare-desc">{p.short_description}</p>
                ) : null}
                <CompareClaims />
                <button
                  type="button"
                  className="asg-compare-btn"
                  onClick={() => window.dispatchEvent(new CustomEvent('asg:open-contact'))}
                >
                  Contact Us
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
